// © Microsoft Corporation. All rights reserved.

import React, { useEffect, useState, useRef } from 'react';
import { Image, ImageFit, Label } from '@fluentui/react';
import { LocalVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import { videoHint, mediaContainer, localVideoContainerStyle, labelnamevideo } from './styles/StreamMedia.styles';
import { Constants } from '../core/constants';
import staticMediaSVG from '../assets/staticmedia.svg';

export interface LocalStreamMediaProps {
  label: string;
  stream: LocalVideoStream;
  selectedPane:string;
}

export const LocalStreamMedia = (props: LocalStreamMediaProps): JSX.Element => {
  const rendererView = useRef<undefined | VideoStreamRendererView>();

  const [activeStreamBeingRendered, setActiveStreamBeingRendered] = useState(false);

  const imageProps = {
    src: staticMediaSVG.toString(),
    imageFit: ImageFit.contain,
    styles: {
      root: {
        width: '100%',
        height: '100%',
        display: activeStreamBeingRendered ? 'none' : 'block'
      }
    }
  };

  const { stream, label ,selectedPane} = props;

  useEffect(() => {
    (async () => {
      if (stream) {
        const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);
        rendererView.current = await renderer.createView({ scalingMode: 'Crop', isMirrored: true });

        const container = document.getElementById(Constants.LOCAL_VIDEO_PREVIEW_ID);

        if (container && container.childElementCount === 0) {
          container.appendChild(rendererView.current.target);
          setActiveStreamBeingRendered(true);
        }
      } else {
        if (rendererView.current) {
          rendererView.current.dispose();
          setActiveStreamBeingRendered(false);
        }
      }
    })();

    return () => {
      if (rendererView.current) {
        rendererView.current.dispose();
        rendererView.current = undefined;
        setActiveStreamBeingRendered(false);
      }
    };
  }, [stream]);

  return (
    <div className={mediaContainer} style={{ background: '#1f1e1e' }}>
      <div className={selectedPane != 'none' ? ' mob_video_bg_panelm1' : ' full_mob_video_bg_panelm1'}>
        <div
          style={{ display: activeStreamBeingRendered ? 'block' : 'none', }}
          className={localVideoContainerStyle}
          id={Constants.LOCAL_VIDEO_PREVIEW_ID}
        />
        <div>
          <Image className={selectedPane != 'none' ? ' mob_video_image_view' : ' full_mob_video_image_view'} style={{ position: 'relative', left: '0px', right: '0px', top: '0px', transform: 'translate(0%, 0%)' }} {...imageProps} />
        </div>
        <Label className={[videoHint, labelnamevideo].join(' ') +' mob_video_name_text'}>{label}</Label>
      </div>
    </div>
  );
};
